import axios from '../requester';
import { API } from '../constants/api-urls';
import {
  getMessages as getMessagesMock,
  markMessagesAsRead as markMessagesAsReadMock,
  removeMessages as removeMessagesMock
} from 'common/services/__mocks__/message-center.service';
import { RUN_IN_MOCK_MODE } from 'common/config/mock-server.config';

export const getMessages = async () => {
  if (RUN_IN_MOCK_MODE) {
    return getMessagesMock();
  }
  return axios.get(API.MESSAGE_CENTER);
};

export const markMessagesAsRead = async messageIds => {
  if (RUN_IN_MOCK_MODE) {
    return markMessagesAsReadMock(messageIds);
  }
  if (Array.isArray(messageIds) && messageIds.length > 1) {
    // Read all notifications to prevent requests with excessively large query parameters.
    const payload = {
      notificationIds: messageIds
    };
    return axios.put(API.MESSAGE_CENTER + `/update_read`, payload);
  }
  return axios.put(API.MESSAGE_CENTER + `/update_read/${messageIds + ''}`);
};

export const removeMessages = async messageIds => {
  if (RUN_IN_MOCK_MODE) {
    return removeMessagesMock(messageIds);
  }
  return axios.delete(API.MESSAGE_CENTER + `/${messageIds + ''}`);
};
